export const MODE = '__mode';

export const MODE_VALUE = {
  NOSS: 'noss',
  NOCS: 'nocs',
};
